import { Injectable } from '@angular/core';
import { createState, Store } from '@ngneat/elf';
import { withActiveId, withEntities } from '@ngneat/elf-entities';
import {
  createRequestsStatusOperator,
  withRequestsStatus,
} from '@ngneat/elf-requests';
import { TestMethod } from '@prisma/client';
import { CRUDRepository } from '../../shared/crud/repository';
import { loadList } from './test-method.actions';
import { TestMethodListGQL } from './test-method.interface';

type StatusPaths = 'list' | 'item';

const { state, config } = createState(
  withEntities<TestMethod>(),
  withActiveId(),
  withRequestsStatus<StatusPaths>()
);

export const store = new Store({ name: 'test-methods', config, state });
export const trackRequestsStatus = createRequestsStatusOperator(store);

@Injectable({ providedIn: 'root' })
export class TestMethodRepository extends CRUDRepository<
  TestMethod,
  typeof store
> {
  constructor() {
    super(store, { loadListAction: loadList });
  }

  public override searchEntity(entity: TestMethodListGQL, searchText: string) {
    searchText = searchText.toLowerCase();
    if (entity.name) {
      if (entity.name?.toLocaleLowerCase().indexOf(searchText) !== -1)
        return true;
    }
    if (entity.technicalDocument?.name) {
      if (
        entity.technicalDocument?.name
          ?.toLocaleLowerCase()
          .indexOf(searchText) !== -1
      )
        return true;
    }
    return false;
  }
}
